import React, { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { PageLoading } from "@tripian/react";
import Model from "@tripian/model";
import {
  NOT_FOUND,
  TRIP_CLONE,
  TRIP_PLAN,
  TIMELINE_PLAN,
} from "../../constants/ROUTER_PATH_TITLE";
import { api } from "@tripian/core";
import { useDispatch } from "react-redux";
import { changeTripReferences } from "../../redux/action/user";
import useTrip from "../../hooks/useTrip";
import {
  changePlans,
  changeReadOnly,
  changeReference,
} from "../../redux/action/trip";
import useTranslate from "../../hooks/useTranslate";

const TripClonePage = () => {
  const { hashParam } = useParams<{ hashParam: string }>();
  const [searchParams] = useSearchParams();
  const isTimeline = searchParams.get("isTimeline") === "true";
  const { tripFetchCallback } = useTrip();

  const { t } = useTranslate();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hashParam) {
      navigate(NOT_FOUND.PATH, { replace: true });
      return;
    }

    api
      .tripCloneCombo(hashParam)
      .then(
        (data: { trip: Model.Trip; tripReferences: Model.TripReference[] }) => {
          dispatch(changeTripReferences(data.tripReferences));
          dispatch(changeReadOnly(false));
          dispatch(
            changeReference({
              id: data.trip.id,
              city: data.trip.city,
              shared: data.trip.shared,
              tripHash: data.trip.tripHash,
              tripProfile: data.trip.tripProfile,
            })
          );
          dispatch(changePlans(data.trip.plans));

          // Redirect to timeline or trip plan based on isTimeline param
          const targetPath = isTimeline ? TIMELINE_PLAN.PATH : TRIP_PLAN.PATH;
          navigate(`${targetPath}/${data.trip.tripHash}`, {
            replace: true,
          });
        }
      );
  }, [dispatch, hashParam, navigate, tripFetchCallback, isTimeline]);

  // useEffect(() => {
  //   api.tripClone(hashParam).then((myClone: Model.Trip) => {
  //     tripFetchCallback(myClone, false);
  //     history.replace(`${TRIP_PLAN.PATH}/${myClone.tripHash}`);
  //   });
  // }, [hashParam, history, tripFetchCallback]);

  document.title = `${TRIP_CLONE.TITLE(t("tripCopy.header"))} - ${hashParam}`;

  return <PageLoading />;
};

export default TripClonePage;
